export default {"src":"/_next/static/media/soyabean.727d7d46.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};